import React from 'react';
import { version } from '../../../package.json'
import moment from 'moment';

export default class Footer extends React.Component {
  render() {
    return (
      <div className="page-footer">
        <div className="row">
          <div className="col-xs-12 col-sm-12">
            <span className="txt-color-white">
              Telemetry {version} - Web Application Hybrid for Healthcare
              Optimization © {moment().format('YYYY')}
            </span>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/Footer.js